'use strict';

angular.module('amexReconciliationApp')
  .component('detailsHeader', {
    templateUrl: 'scripts/views/components/details-header.html',
    controller: function (SiteConfigModel,
                          ActiveTransactionModel,
                          CompanyRepository,
                          UserModel,
                          BillingCycleModel,
                          TransactionSearchModel) {
      var self = this;

      self.activeTransaction = ActiveTransactionModel.activeTransaction;
      self.approvalSettingOnForRole = SiteConfigModel.approvalSettingOnForRole;
      self.cardNumber = self.activeTransaction().cardNumber;
      self.cardmemberName = self.activeTransaction().cardmemberName;
      self.companyName = SiteConfigModel.siteConfig().companyName;
      self.bcaNumber = bcaNumber();
      self.siteName = SiteConfigModel.siteConfig().siteName;
      self.isBta = SiteConfigModel.isBta;
      self.siteNumber = SiteConfigModel.siteConfig().siteNumber;
      self.billingCycleStartDate = getCurrentBillingCycleStartDate();
      self.billingCycleEndDate = getCurrentBillingCycleEndDate();
      self.travelerName = self.activeTransaction().details.travelerName;
      self.amount = self.activeTransaction().amount;
      self.billedCurrency = self.activeTransaction().details.billedCurrency;

      self.displayCardmemberDetails = function () {
        return TransactionSearchModel.isCardManager();
      };

      self.displayBcaAccountDetails = function () {
        return TransactionSearchModel.isBcaManager();
      };

      self.showTransactionAmount = function() {
        return (self.displayCardmemberDetails() || self.displayBcaAccountDetails());
      };

      self.getCurrencyFormat = UserModel.getCurrencyFormat;

      function getCurrentBillingCycleStartDate() {
        var billingCycle = _.find(BillingCycleModel.billingCycles(), ['endDate', TransactionSearchModel.billingCycle().endDate]);
        return _.get(billingCycle, 'startDate', 0);
      }

      function getCurrentBillingCycleEndDate() {
        return _.get(TransactionSearchModel.billingCycle(), 'endDate', 0);
      }

      function bcaNumber() {
        return _.get(TransactionSearchModel.bca(), 'bca', '');
      }
    }
  });


//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/components/detailsHeader.js
// module id = 447
// module chunks = 0